export default "__VITE_ASSET__D28Teggj__"